import React from 'react';
import FeedModal from '../Feed/FeedModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadNewPhotos, loadNewMarketing, loadNewPhotosInicial, removePhotos, showMarketing } from '../../store/photos';
import IdeasContent from './IdeasContent';
import useForm from '../../Hooks/useForm';

const Photos = (props) => {
  const { list, infinite, pages } = useSelector((state) => state.photos);
  const dispatch = useDispatch();
  const [modalPhoto, setModalPhoto] = React.useState(null);




  React.useEffect(() => {
    dispatch(removePhotos());
    dispatch(loadNewMarketing(7));    
    dispatch(loadNewPhotos(props.area_id));
  }, [dispatch]);

  React.useEffect(() => {
    let wait = false;
    function infiniteScroll() {
      if (infinite) {
        const scroll = window.scrollY;
        const height = document.body.offsetHeight - window.innerHeight;
        if (scroll > height * 0.75 && !wait) {
          dispatch(showMarketing());
          dispatch(loadNewPhotos(props.area_id));
          wait = true;
          setTimeout(() => {
            wait = false;
          }, 500);
        }
      }
    }
  
    window.addEventListener('wheel', infiniteScroll);
    window.addEventListener('scroll', infiniteScroll);
    return () => {
      window.removeEventListener('wheel', infiniteScroll);
      window.removeEventListener('scroll', infiniteScroll);
    };
  }, [infinite, dispatch]);

    
  return (
    <>
      {modalPhoto && (
        <FeedModal photo={modalPhoto} setModalPhoto={setModalPhoto} />
      )}
      {list.length > 0 && <IdeasContent setModalPhoto={setModalPhoto} />}
      
    </>
  );
};

export default Photos;
